import { render, staticRenderFns } from "./testForAndroid.vue?vue&type=template&id=41e336ac&scoped=true"
import script from "./testForAndroid.vue?vue&type=script&lang=js"
export * from "./testForAndroid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e336ac",
  null
  
)

export default component.exports